"use client";
//#region packages/@mantine/core/src/components/UnstyledButton/UnstyledButton.module.css
var UnstyledButton_module_default = { "root": "m_87cf2631" };
//#endregion
export { UnstyledButton_module_default as default };

//# sourceMappingURL=UnstyledButton.module.mjs.map